import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'

import { FiArrowUp } from 'react-icons/fi'
// react-icons returns ReactNode; TS 4 used by CRA expects a JSX element here.
const ArrowUpIcon = FiArrowUp as React.ComponentType<{ className?: string }>;

export default function ScrollToTop() {
    let[scroll,setScroll] = useState<boolean>(false)

    const scrollToTop = () =>{
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({top: 0, behavior: reduceMotion ? 'auto' : 'smooth'});
    }

    useEffect(()=>{

        const handlerScroll=()=>{
            if(window.scrollY > 50){
                setScroll(true)
            }else{setScroll(false)}
        }
        window.addEventListener('scroll',handlerScroll)

        return () => {
            window.removeEventListener('scroll',handlerScroll)
          };
    },[])

  return (
    <Link id="back2Top" onClick={()=>scrollToTop()} className={`top-scroll ${scroll ? 'd-block' : ''}`} title="Back to top" to="#"><ArrowUpIcon className="ti-arrow-up"/></Link>
  )
}
